import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/hooks/useAuth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Sales from "@/pages/Sales";
import Stock from "@/pages/Stock";
import Fabrics from "@/pages/Fabrics";
import Transfers from "@/pages/Transfers";
import Warehouses from "@/pages/Warehouses";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import Audit from "@/pages/Audit";
import Alerts from "@/pages/Alerts";
import Clients from "@/pages/Clients";
import Accounting from "@/pages/Accounting";
import Purchases from "@/pages/Purchases";
import Manual from "@/pages/Manual";
import SettingsPage from "@/pages/Settings";
import { SettingsProvider } from "@/hooks/useSettings";

const Guard = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Guard><Layout /></Guard>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/ventes" element={<Sales />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/tissus" element={<Fabrics />} />
            <Route path="/transferts" element={<Transfers />} />
            <Route path="/rapports" element={<Reports />} />
            <Route path="/alertes" element={<Alerts />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/comptabilite" element={<Accounting />} />
            <Route path="/achats" element={<Purchases />} />
            <Route path="/manuel" element={<Manual />} />
            <Route path="/journal" element={<Audit />} />
            <Route path="/parametres" element={<Guard roles={["admin"]}><SettingsPage /></Guard>} />
            <Route path="/depots" element={<Guard roles={["admin"]}><Warehouses /></Guard>} />
            <Route path="/utilisateurs" element={<Guard roles={["admin"]}><Users /></Guard>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </SettingsProvider>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
